module.exports = "/images/Sell Party and group sales.svg?3262ea0470c60886566eafe6c5eac642";